/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_RefreshInputs */

const vi_einvoice_refresh = /** @type {(inputs: Einvoice_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Làm mới trạng thái`)
};

/**

* @param {Einvoice_RefreshInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_refresh = /** @type {((inputs?: Einvoice_RefreshInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_RefreshInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_refresh(inputs)
});